import React from 'react';

import style from './banner.module.scss';

export const Banner = () => {
    return (
        <div className={style.banner}>
            <div className={style.bannerTextContainer}>
                <p className={style.bannerText}>About Wintech seals</p>
            </div>
        </div>
    );
};
